import CompanyData from './CompanyData';

export default CompanyData;
